import React, { useState } from 'react';
import RangeSlider from 'react-bootstrap-range-slider';

const RangeInputSlider = (props) => {

  
  return (
    
    <RangeSlider
      value={props.widthValue}
      onChange={changeEvent => {

        props.onChangeHandler(changeEvent.target.value)
        }}
      max={props.maxWidthRange}
      min={0}
      step={props.step ? props.step:1.00}
    />
  );

};
export default RangeInputSlider;